<script setup lang="ts">
import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import {
  DepartmentDataPayload,
  DepartmentDataResponse,
} from "@/types/interface/department";
import { useDepartmentStore } from "@/stores/master/department";

const idDepartment = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const storeDepartment = useDepartmentStore();
const detailDepartment = ref<DepartmentDataResponse>();

const validationSchema = toTypedSchema(
  zod.object({
    code: zod.string().nonempty({ message: "Code is required" }),
    name: zod.string().nonempty({ message: "Department is required" }),
    // parent_dept_id: zod.number(),
    description: zod.string().nonempty({ message: "Description is required" }),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: code } = useField<string>("code");
const { value: name } = useField<string>("name");
// const { value: parent_dept_id } = useField<string>("parent_dept_id");
const { value: description } = useField<string>("description");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadDepartment: DepartmentDataPayload = {
    code: code.value,
    name: name.value,
    // parent_dept_id: parseInt(parent_dept_id.value),
    description: description.value,
  };
  const responseApi = ref<any>();
  if (isEdit.value == true) {
    responseApi.value = await storeDepartment.dispatchUpdate(
      idDepartment.value,
      payloadDepartment
    );
  } else {
    responseApi.value = await storeDepartment.dispatchCreate(payloadDepartment);
  }
  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "Department Successfully Updated"
          : "Department Successfully Added"
      );
      router.push("/master/department");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadDetailDepartment = async () => {
  const { success, message } = await storeDepartment.dispatchDetail(
    idDepartment.value
  );
  if (success) {
    detailDepartment.value = await storeDepartment.department.data;
    code.value = detailDepartment.value?.code;
    name.value = detailDepartment.value?.name;
    description.value = detailDepartment.value?.description;
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idDepartment.value = router.currentRoute.value.params.id.toString();
    loadDetailDepartment();
  }
});
</script>
<template>
  <div class="row justify-content-center">
    <div class="col-lg-12">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
          >
            <h3 class="mb-0">Form Create Department</h3>
            <a
              class="btn btn-danger fw-semibold text-white px-3"
              type="button"
              href="/master/department"
            >
              <i class="ri-arrow-drop-left-line text-gray-light"></i>
              Back To List Department
            </a>
          </div>
          <BaseLoading text="Processing Data..." v-if="isLoading" />
          <form
            @submit="onSubmit"
            class="row g-3 needs-validation form"
            v-if="!isLoading"
          >
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="code" class="form-label label text-secondary"
                    >Code <span class="text-danger">*</span></label
                  >
                  <div class="position-relative">
                    <input
                      name="code"
                      v-model="code"
                      placeholder="Department Code"
                      type="text"
                      class="form-control text-dark"
                    />
                  </div>
                  <span class="text-danger">{{ errors.code }}</span>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="name" class="form-label label text-secondary"
                    >Department <span class="text-danger">*</span></label
                  >
                  <div class="position-relative">
                    <input
                      name="name"
                      v-model="name"
                      placeholder="Department"
                      type="text"
                      class="form-control text-dark"
                    />
                  </div>
                  <span class="text-danger">{{ errors.departments }}</span>
                </div>
              </div>
              <!-- <div class="col-lg-6">
                <div class="form-group">
                  <label
                    for="parent_dept_id"
                    class="form-label label text-secondary"
                    >Department Parent <span class="text-danger">*</span></label
                  >
                  <div class="position-relative">
                    <input
                      name="parent_dept_id"
                      v-model="parent_dept_id"
                      placeholder="Departmen Parent"
                      type="number"
                      class="form-control text-dark"
                    />
                  </div>
                  <span class="text-danger">{{ errors.parent_dept_id }}</span>
                </div>
              </div> -->
              <div class="col-lg-6">
                <div class="form-group">
                  <label
                    for="description"
                    class="form-label label text-secondary"
                    >Description</label
                  >
                  <div class="position-relative">
                    <textarea
                      name="description"
                      v-model="description"
                      placeholder="Description"
                      class="form-control text-dark"
                    />
                  </div>
                  <span class="text-danger">{{ errors.description }}</span>
                </div>
              </div>
              <div class="col-12 mt-5">
                <button
                  class="btn btn-primary fw-semibold text-white py-2 px-3"
                  type="submit"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
